import { normalize } from 'normalizr';
import questionTypes, { INFORMATION_CONTENT } from 'constants/questionTypes';
import courseSchema from '../schemas/course/course';
import { objectToArray } from 'utils/object';
import { hashData } from 'utils/compression';

/* eslint-disable import/prefer-default-export */
export default {
  map: (data: any, showContentPages: boolean) => {
    const informationContent = getInformationContentIds(data);
    const normalized: any = normalize(filterCourseData(data, showContentPages), courseSchema);
    const course: any = normalized.entities.course[normalized.result];
    const { sections, questions, contents } = normalized.entities;
    course.checksum = hashData(getQuestionsStructure(questions));

    return {
      course,
      sections,
      questions,
      contents,
      informationContent
    };
  }
};

function getInformationContentIds(data: any) {
  let informationContentIds: string[] = [];
  data.sections.forEach((section: any) => {
    informationContentIds = informationContentIds.concat(
      section.questions
        .filter((question: any) => question.type === INFORMATION_CONTENT)
        .map((question: any) => question.id)
    );
  });

  return informationContentIds;
}

function filterCourseData(data: any, showContentPages: boolean) {
  data.sections = data.sections.filter((section: any) => {
    section.questions = section.questions.filter((question: any) => {
      question.attemptNumber = 0;
      return questionTypes.includes(question.type);
    });
    if (!showContentPages) {
      section.questions = section.questions.filter(
        (question: any) => question.type !== INFORMATION_CONTENT
      );
    }
    return section.questions.length > 0;
  });
  return data;
}

function getQuestionsStructure(questions: any) {
  return objectToArray(questions).map((question: any) => [
    question.id,
    question.answers ? question.answers.map((answer: any) => answer.id) : ''
  ]);
}
